import { useTimelinePager } from 'framework/ViewTypes/embeddable';
import { type FilterState } from 'framework/ViewTypes/components';
import { FilterCondition } from 'framework/types';
import { POSITION_PROFILE_TIMELINE_TYPES } from '../../../constants';
import { DESC } from 'framework/list';
import type { PositionProfileTimelineEvent } from '../../../types';
import usePositionProfileTimelineService from 'domain/people/positionProfiles/usePositionProfileTimelineService';

const usePositionProfileTimeline = (profileId: string, enabled: boolean) => {
  const { getTimeline, getTimelinePageById } = usePositionProfileTimelineService();

  return useTimelinePager<PositionProfileTimelineEvent, FilterState>({
    viewParamsConfig: {
      defaultSortBy: 'createdAt',
      defaultSortOrder: DESC,
      filterRules: {
        type: { condition: FilterCondition.IN, values: Object.values(POSITION_PROFILE_TIMELINE_TYPES) },
      },
      sortableColumns: ['createdAt'],
    },
    collectionKey: profileId,
    pageSize: 30,
    enabled,
    fetchPage: async ({ pageNumber, pageSize, filters, sort, signal }) => {
      const response = await getTimeline(
        profileId,
        {
          pageNumber,
          pageSize,
          filter: filters,
          sort,
        },
        { signal },
      );
      return { ...response, totalElements: response.totalElements ?? response.result.length };
    },
    fetchEntryPage: async (timelineEntryId, { pageSize, filters, sort, signal }) => {
      const response = await getTimelinePageById(
        profileId,
        timelineEntryId,
        {
          pageNumber: 0,
          pageSize,
          filter: filters,
          sort,
        },
        { signal },
      );
      return { ...response, totalElements: response.totalElements ?? response.result.length };
    },
  });
};

export default usePositionProfileTimeline;
